import { ToggleButtonOption } from "../components/form/APFormToggleGroup";

export const termOptions: ToggleButtonOption[] = [
  { label: "12mth", id: "12" },
  { label: "24mth", id: "24" },
  { label: "36mth", id: "36" },
  { label: "48mth", id: "48" },
  { label: "60mth", id: "60" },
];
